'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCurrentUserToken = exports.setCurrentUserToken = exports.getCurrentUserToken = undefined;

var _localStorage = require('../utils/services/localStorage/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

var _authConstants = require('./authConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Services
var getCurrentUserToken = exports.getCurrentUserToken = function getCurrentUserToken() {
  return _localStorage2.default.getItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY);
};

// Constants
var setCurrentUserToken = exports.setCurrentUserToken = function setCurrentUserToken(value) {
  return _localStorage2.default.setItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY, value);
};

var removeCurrentUserToken = exports.removeCurrentUserToken = function removeCurrentUserToken() {
  return _localStorage2.default.removeItem(_authConstants.USER_LOCAL_STORAGE_TOKEN_KEY);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/authService.js
// module id = 227
// module chunks = 0